import { FirebaseOptions, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { Database, getDatabase } from 'firebase/database';
import { Firestore, connectFirestoreEmulator, initializeFirestore } from 'firebase/firestore';
import { createContext, useContext } from 'react';

export type FirebaseContextType = {
  auth: Auth;
  db: Firestore;
  rtdb: Database;
};

export const FirebaseContext = createContext<FirebaseContextType | null>(null);

export function FirebaseProvider({ children }: { children: React.ReactNode }) {
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig: FirebaseOptions = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL:
      process.env.REACT_APP_REALTIME_DATABASE || process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };

  const app = initializeApp(firebaseConfig);

  // const db = getFirestore(app);
  const db = initializeFirestore(app, {
    ignoreUndefinedProperties: true,
  });

  const rtdb = getDatabase(
    app,
    process.env.REACT_APP_REALTIME_DATABASE || process.env.REACT_APP_FIREBASE_DATABASE_URL
  );

  const auth = getAuth();
  const firebaseContext = { db: db, auth: auth, rtdb: rtdb };

  // Use local emulator if app is started from localhost
  if (process.env.REACT_APP_FIREBASE_EMULATOR == 'true') {
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
  }

  return <FirebaseContext.Provider value={firebaseContext}>{children}</FirebaseContext.Provider>;
}

export function useFirebase() {
  const context = useContext(FirebaseContext);

  if (!context) {
    throw new Error('useFirebase must be used within a FirebaseProvider');
  }

  return context;
}
